export const OPERATION = "OPERATION";
export const CUSTOMER_SERVICE = "CUSTOMER_SERVICE";
export const FINANCE = "FINANCE";
export const CMS_ADMIN = "CMS_ADMIN";
export const ROUTE_PLANNER = "ROUTE_PLANNER";
